import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/client/lib/api-client'

// Types — matches what the update server returns inside { success, stats }
export interface Stats {
  plugins: number
  themes: number
  licenses: number
  downloads: number
}

/** Raw response from the update server proxy */
interface StatsResponse {
  success: boolean
  stats: Stats
}

// Query keys
export const statsKeys = {
  all: ['stats'] as const,
}

// Hooks
export function useStats() {
  return useQuery({
    queryKey: statsKeys.all,
    queryFn: async () => {
      const response = await apiClient.get<StatsResponse>('/api/update-server/stats')
      return response.stats
    },
  })
}
